import classnames from 'classnames'
import { forwardRef } from 'react'

import { CaseStudyCard } from './case-study-card'
import styles from './styles.module.scss'

const CASE_STUDIES = [
  {
    companyName: 'Hapana',
    caseResume:
      "Hapana is the only end-to-end software solution built to deliver engagement and growth for ambitious fitness businesses. Proudly founded in Sydney Australia, Hapana delights over a million members in more than 10 countries and is trusted by brands such as BFT, UFC Gym, Gold’s Gym, KX Pilates, LTYB, GoYoga, Vive Active, and many more. Since 2019 Olby extends Hapana's engineering and design teams and helps making sure their products scale globally.",
    badgeList: ['fitness', 'crm'],
    href: '/blog/case-studies/hapana',
    imageHref: 'https://platform-statics.olby.com/case-studies/hapana.png',
  },
  {
    companyName: 'Benepass',
    caseResume:
      'Benepass is a growing startup headquartered in the Greater New York Area and baked by investors like Y-Combinator, GFC, Gradient Ventures, and more. They help companies take care of their people by providing a platform to distribute benefits and non-salary compensation globally flexibly. Olby has worked with them since 2021, helping to source, vet, hire, onboard and retain their team in Brazil from the ground up.',
    badgeList: ['employee benefits', 'fintech'],
    href: '/blog/case-studies/benepass',
    imageHref: 'https://platform-statics.olby.com/case-studies/benepass.png',
  },
  {
    companyName: 'Pythonic',
    caseResume: 'Pythonic Corporation specializes in developing and applying advanced natural language and computer vision models, primarily focusing on the title insurance industry. Recognizing the unique needs of Pythonic`s tech division, Olby sourced and selected highly skilled software developers - a precise match of skills and culture that laid a solid foundation for Pythonic`s global team.',
    badgeList: ['artificial intelligence', 'machine learning'],
    href: '/blog/case-studies/pythonic',
    imageHref: 'https://platform-statics.olby.com/case-studies/pythonic.png',
  },
  {
    companyName: 'Dvora Life',
    caseResume:
      '  Dvora Life is a Real Estate company that showcases a portfolio of over 20 luxury properties across New Jersey and New York. Their platform provides a complete residential experience for members in multifamily buildings and offers property management tools for landlords. With a global vision for hiring and expansion, Dvora Life partnered with Olby to enhance their Engineering team, transforming their innovative concepts into great digital products.',
    badgeList: ['real estate', 'leasing', 'property management'],
    href: '/blog/case-studies/dvora',
    imageHref: 'https://platform-statics.olby.com/case-studies/dvora.png',
  },
  {
    companyName: 'ShareThis',
    caseResume:
      'ShareThis Inc., is a technology company headquartered in Palo Alto, CA, with offices in New York, Chicago, and Los Angeles. It offers tools that allows sharing of content across 40+ social channels and are used by over three million publishers globally. Since 2019 Olby has been helping ShareThis scaling their tech teams to deliver new products faster.',
    badgeList: ['advertising', 'analytics', 'social media'],
    href: '/blog/case-studies/share-this',
    imageHref: 'https://platform-statics.olby.com/case-studies/sharethis.png',
  },
  {
    companyName: 'SwingDev',
    caseResume:
      'SwingDev is a software development consultancy from California that helps promising companies grow. They partner with firms worldwide to build incredible products, giving them a cornerstone for commercial success. For nearly a decade, SwingDev has been providing the highest quality services for tech companies at different stages – from high-growth startups to Fortune 500 enterprises – by helping them with engineering, product design, and development.',
    badgeList: ['consulting', 'development', 'design'],
    href: '/blog/case-studies/swing-dev',
    imageHref: 'https://platform-statics.olby.com/case-studies/swingdev.png',
  },
  {
    companyName: 'Loadsmart',
    caseResume:
      'Loadsmart is a leading freight technology company from Chicago, Illinois. The platform enables shippers, carriers, and brokers to efficiently manage an automated supply chain. In 2022 Loadsmart announced it had closed a $200 million Series D round led by SoftBank Latin America Fund, which values the company at $1.3 billion. Olby talent joined Loadsmart in 2021, scaling their teams and helping to create technologies that are becoming the new industry standard.',
    badgeList: ['logistics', 'transportation'],
    // TODO: add link when we have the blog post
    // href: '/',
    imageHref: 'https://platform-statics.olby.com/case-studies/loadsmart.png',
  },
  {
    companyName: 'Great Big Events',
    caseResume:
      "Great Big Events is an international Sport Presentation and Event Management company with offices in Sydney Australia, London United Kingdom and Doha Qatar with satellite offices around North America, Europe, Gulf Region and Australasia. Among its many notable sporting events, the company has produced the Sydney 2000, Beijing 2008, and London 2012 Olympic and Paralympic Games. Since 2018 Olby provides tech talent for GBE's innovation division with multiple products launch at scale.",
    badgeList: ['events', 'sports'],
    // TODO: add link when we have the blog post
    // href: '/',
    imageHref: 'https://platform-statics.olby.com/case-studies/gbe.png',
  },
]

export const CaseCardsSection = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section className={styles['case-studies-section']} ref={ref}>
      {/* TODO: Add correct images for each case study */}
      {CASE_STUDIES.map((caseStudy, index) => (
        <CaseStudyCard
          className={classnames(styles['case-study-card'], {
            [styles['right-aligned']]: index % 2 !== 0,
          })}
          key={caseStudy.companyName}
          companyName={caseStudy.companyName}
          caseResume={caseStudy.caseResume}
          badgeList={caseStudy.badgeList}
          href={caseStudy.href}
          image={caseStudy.imageHref}
        />
      ))}
    </section>
  )
})

export default CaseCardsSection
